import React, { memo } from 'react';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
    logo: {
        height: '30px',
        maxHeight: '32px',
        display: 'block',
        marginLeft: 'auto',
        marginRight: 'auto'
    }
}));

const Logo = ({ width = 128, height = 30, className }) => {
    const { classes, cx } = useStyles();

    return (
        <img
            width={width}
            height={height}
            className={cx(classes.logo, className)}
            src='https://specterr.b-cdn.net/specterr-logo.svg'
            alt='Specterr logo'
        />
    );
}

export default memo(Logo);
